export type ActivityItemData = {};

export type ActivityPagination = {
  "@id": string;
  type: string;
  first: string;
  last: string;
  previous: string;
  next: string;
};

export type ActivitySearchMappingItem = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
};

export type ActivitySearch = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: ActivitySearchMappingItem[];
};

export type ActivityListResponse = {
  member: ActivityItemData[];
  totalItems: number;
  view: ActivityPagination;
  search: ActivitySearch;
};

export type ActivityPageState = {
  page: number;
  itemsPerPage?: number;
  pagination?: boolean;
  name?: string | null;
  address?: string | null;
  reference?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
};

export type ActivityListStateType = {
  pageState: ActivityPageState;
  setPageState: (state: ActivityPageState) => void;
  resetPageState: () => void;
};

export const initialActivityPageState: ActivityPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
